var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { IconButton } from "./IconButton";
import styles from "./IconMenu.module.scss";
import buttonStyles from "./IconButton.module.scss";
import { useDeferredOver } from "@/utils/useDeferredHover";
import { useIsDesktop } from "../../utils/useIsDesktop";
export function IconMenu(_a) {
    var _b, _c;
    var _d = _a.menu, content = _d.content, _e = _d.position, position = _e === void 0 ? "top" : _e, _f = _d.theme, theme = _f === void 0 ? "light" : _f, size = _d.size, holderClass = _d.holderClass, menuClass = _d.class, onToggle = _a.onToggle, _g = _a.arrow, arrow = _g === void 0 ? false : _g, _h = _a.trigger, _trigger = _h === void 0 ? "click" : _h, children = _a.children, props = __rest(_a, ["menu", "onToggle", "arrow", "trigger", "children"]);
    var isDesktop = useIsDesktop();
    var trigger = isDesktop ? _trigger : "click";
    var _j = __read(useState(false), 2), visible = _j[0], _setVisible = _j[1];
    var setVisible = useCallback(function (v) {
        _setVisible(v);
        if (v !== visible) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(v);
        }
    }, [visible, onToggle]);
    var menuElement = useRef(null);
    useEffect(function () {
        function onClick(e) {
            if (e.target != null &&
                menuElement.current != null &&
                !isInParent(e.target, menuElement.current)) {
                setVisible(false);
            }
        }
        if (visible && trigger === "click") {
            document.body.addEventListener("click", onClick);
            return function () {
                document.body.removeEventListener("click", onClick);
            };
        }
    }, [visible, setVisible, trigger]);
    var _k = useDeferredOver(), buttonHover = _k.hover, onEnterButton = _k.onMouseEnter, onLeaveButton = _k.onMouseLeave;
    var _l = useDeferredOver(), menuHover = _l.hover, onEnterMenu = _l.onMouseEnter, onLeaveMenu = _l.onMouseLeave;
    var hoverVisible = useMemo(function () { return buttonHover || menuHover; }, [buttonHover, menuHover]);
    useEffect(function () {
        if (trigger === "hover") {
            setVisible(hoverVisible);
        }
    }, [trigger, hoverVisible, setVisible]);
    return (React.createElement("div", { className: styles.iconMenu },
        React.createElement(IconButton, __assign({}, props, { onClick: trigger == "click" ? function () { return setVisible(!visible); } : props.onClick, onMouseEnter: onEnterButton, onMouseLeave: onLeaveButton, className: classNames(styles.button, (_b = {}, _b[buttonStyles.hover] = visible, _b)), tooltip: !visible && trigger === "click" ? props.tooltip : undefined }), children),
        React.createElement("div", { className: classNames(styles.menuHolder, holderClass) },
            React.createElement("div", { ref: menuElement, onMouseEnter: onEnterMenu, onMouseLeave: onLeaveMenu, className: classNames(styles.menu, menuClass, (_c = {},
                    _c[styles.visible] = visible,
                    _c[styles.dark] = theme === "dark",
                    _c[styles.light] = theme === "light",
                    _c[styles.transparent] = theme === "transparent",
                    _c[styles.arrow] = arrow,
                    _c[styles.menuLeft] = ["top-left", "bottom-left"].includes(position),
                    _c[styles.menuRight] = ["top-right", "bottom-right"].includes(position),
                    _c[styles.medium] = size === "medium",
                    _c[styles.large] = size === "large",
                    _c), ["bottom", "bottom-left", "bottom-right"].includes(position)
                    ? styles.menuBottom
                    : styles.menuTop), onClick: function (e) { return e.stopPropagation(); } },
                typeof content === "function"
                    ? content(function () { return setVisible(false); })
                    : content,
                trigger === "hover" && props.tooltip && (React.createElement("div", { className: styles.tooltip }, props.tooltip.label))))));
}
function isInParent(element, parent) {
    if (element === parent)
        return true;
    if (element.parentElement == null)
        return false;
    return isInParent(element.parentElement, parent);
}
